import React from 'react';
import {Title, Video} from './../../Basics';

const Particle21 = () => (<div>

  <Title>Selbsttest: Wie geht Gedankensteuerung?</Title>
  <Video
    source={require('./BCI_DEF.mp4')}
    poster={require('./21_preview.png')}
  />

</div>);

export default Particle21;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle21/Particle21.js
 **/